module.exports = __webpack_public_path__ + "img/2024-12-12c_1.536ebbfb.jpg";